import React, { useState, useEffect, useContext } from 'react'
import { cols, colsMenoTaglia } from '../../molecules/NewTableSchedaProdotto/NewTableSchedaProdotto'
import Datatable from '../../../components/atoms/Datatable/Datatable'
import Button from '../../atoms/Button/Button'
import DatatableRowProdotto from '../../molecules/DatatableRowProdotto/DatatableRowProdotto'
import { QuantitaContext } from '../../../context/QuantitaContext'
import { api } from '../../../utils/index'
import { CARRELLO, RIGHECARRELLO } from '../../../utils/endpoint'
import FormRadio from '../../atoms/FormRadio/FormRadio'
import _ from 'lodash'
import { displayNotification } from '../../atoms/Notifica/Notifica'
import NewModal from '../../molecules/NewModal/NewModal'
import ModalBlocks from '../../molecules/ModalBlocks/ModalBlocks'
import Alert from '../../atoms/Alert/Alert'
import useTrans from '../../../hooks/useTrans'

const ModificaArticoli = ({
  isVisible,
  setVisible,
  preventivo,
  prodotto,
  service_gift,
  setCarrello,
  initialStep,
  initialId,
  initialSelectedArticolo,
  initialQuantitaProps,
  SubmitFromProps,
}) => {
  const t = useTrans()
  const {
    onChangeInputQuantita,
    updateQuantita,
    getQuantita,
    resetQuantita,
    getError,
    getMassimaQuantitaPrenotabile,
  } = useContext(QuantitaContext)
  const [step, setStep] = useState(initialStep ? initialStep : 0)
  const [Articoli, setArticoli] = useState(preventivo?.righe_carrello)
  const [initialQuantita, setInitialQuantita] = useState(
    initialQuantitaProps ? initialQuantitaProps : null
  )
  const [selectedArticolo, setSelectedArticolo] = useState(
    initialSelectedArticolo ? initialSelectedArticolo : null
  )
  const [id, setId] = useState(initialId ? initialId : null)
  const [Loading, setLoading] = useState(false)

  useEffect(() => {
    initialSelectedArticolo && setSelectedArticolo(initialSelectedArticolo)
    initialId && setId(initialId)
    initialQuantitaProps && setInitialQuantita(initialQuantitaProps)
  }, [initialSelectedArticolo])

  useEffect(() => {
    initialQuantitaProps && setInitialQuantita(initialQuantitaProps)
  }, [initialQuantitaProps])

  useEffect(() => {
    setArticoli(preventivo?.righe_carrello)
  }, [preventivo])

  const _updatePreventivo = async () => {
    try {
      const new_righe = [...preventivo?.righe_carrello]
      new_righe.forEach(
        (riga) =>
          riga?.articolo?.codice === selectedArticolo?.codice &&
          _.set(riga, 'quantita', getQuantita(selectedArticolo?.codice))
      )
      const riga_id = new_righe.filter((obj) => obj.articolo_id === selectedArticolo?.id)[0]?.id
      const new_quantita_articolo = new_righe.filter((obj) => obj.articolo_id === selectedArticolo?.id)[0]?.quantita

      setLoading(true)

      await api
        .patch(RIGHECARRELLO + riga_id + '/', {
          quantita: getQuantita(selectedArticolo?.codice),
        })
        .then(() => {
          displayNotification(
            'success.edit.cart',
            t(`Hai modificato la quantità dell'articolo {0}`, [selectedArticolo?.codice])
          )
        })
        .catch((err) => displayNotification('error.edit.cart', err.message, 'error'))

      await api.get(CARRELLO + preventivo.id + '/').then((response) => {
        setCarrello(response.data)
        setLoading(false)
        !initialSelectedArticolo && setStep(0)
        setVisible(false)
        updateQuantita(selectedArticolo?.codice, new_quantita_articolo)
        // resetQuantita(selectedArticolo?.codice)
      })
    } catch (error) {
      console.log(error)
      setLoading(false)
      displayNotification('error.edit.cart', error.message, 'error')
    }
  }

  const _handleArticolo = () => {
    const selected = Articoli && Articoli.filter((articolo) => articolo.id === id.id)[0]
    const selected_prodotto =
      prodotto && prodotto.articoli.filter((articolo) => articolo.codice === id.codice)[0]
    setInitialQuantita(selected?.quantita)
    setSelectedArticolo(selected_prodotto)
    setStep(1)
  }

  const onModalCancel = () => {
    if (step === 0 || initialStep) setVisible(false)
    else {
      setStep(step - 1)
      updateQuantita(selectedArticolo?.codice, initialQuantita)
    }
  }

  const onModalConfirm = () => {
    if (step === 0) {
      _handleArticolo()
    } else {
      if (SubmitFromProps) {
        // Invochiamo il metodo anche quando l'utente clicca il bottone per aggiornare quantità senza averla modificata
        // (siamo sicuri che venga impostata correttamente la prenotazione se necessario)
        if (initialQuantita === getQuantita(selectedArticolo?.codice)) {
          onChangeInputQuantita(
            selectedArticolo?.id,
            selectedArticolo?.codice,
            initialQuantita,
            getMassimaQuantitaPrenotabile(selectedArticolo),
            selectedArticolo.acquistabile_multipli || 0,
            selectedArticolo.disponibilita,
            selectedArticolo.prossimi_arrivi,
            true,
            selectedArticolo?.escludi_da_listino_di_stampa || null
          )
        }
        SubmitFromProps()
      } else _updatePreventivo()
    }
  }

  const isDisabled = () => {
    const error_multipli = getError(selectedArticolo?.codice)
    const error_quantita = getQuantita(selectedArticolo?.codice) > 0 ? false : true

    if (!error_multipli && !error_quantita) {
      return false
    } else {
      return true
    }
  }

  const modalActions = [
    <Button
      label={t('Annulla e torna indietro')}
      onClick={onModalCancel}
      variant={step === 0 ? 'primary' : 'secondary'}
    />,
    <Button
      label={step === 1 ? t('Aggiorna quantità') : t('Conferma e procedi')}
      onClick={onModalConfirm}
      variant={step === 0 ? 'secondary' : 'primary'}
      disabled={step === 0 ? (!id ? true : false) : isDisabled() ? true : false}
    />,
  ]

  const modalParams = getModalParams(
    step,
    id,
    Articoli,
    setId,
    selectedArticolo,
    initialQuantitaProps || initialQuantita,
    service_gift,
    prodotto
  )

  return Loading ? (
    <NewModal visible={isVisible}>
      <ModalBlocks.Loading />
    </NewModal>
  ) : (
    <NewModal visible={isVisible} onClose={onModalCancel} actions={modalActions} {...modalParams} />
  )
}

const getModalParams = (
  step,
  id,
  Articoli,
  setId,
  selectedArticolo,
  initialQuantita,
  service_gift,
  prodotto
) => {
  switch (step) {
    case 0:
      return getScegliArticoloParams(setId, id, Articoli)
    case 1:
      return getModificaQuantitaModalParams(
        selectedArticolo,
        initialQuantita,
        service_gift,
        prodotto
      )
  }
}

const getScegliArticoloParams = (setId, id, Articoli) => {
  const t = useTrans()

  const getLabel = (preventivo_item) => {
    return !preventivo_item?.personalizzazione_carrello
      ? t('Codice: {0} {1} pz', [preventivo_item?.articolo.codice, preventivo_item?.quantita])
      : t('Codice: {0} {1} pz, Personalizzazione: {2}', [
        preventivo_item?.articolo.codice,
        preventivo_item?.quantita,
        preventivo_item?.personalizzazione_carrello?.nome_lavorazione,
      ])
  }
  return {
    title: t('Cosa desideri modificare?'),
    text: '',
    children: Articoli ? (
      Articoli?.map((preventivo_item) => (
        <div key={preventivo_item.id} style={{ textAlign: 'left' }}>
          <FormRadio
            key={preventivo_item?.id}
            checked={id?.id === preventivo_item?.id ? true : false}
            onClick={() => {
              setId(
                Object.assign(
                  {},
                  { id: preventivo_item?.id, codice: preventivo_item?.articolo.codice }
                )
              )
            }}
            label={getLabel(preventivo_item)}
          />
        </div>
      ))
    ) : (
      <></>
    ),
  }
}

const getModificaQuantitaModalParams = (
  selectedArticolo,
  initialQuantita,
  service_gift,
  prodotto
) => {
  const t = useTrans()

  return {
    title: t('Modifica la quantità del prodotto'),
    className: 'edit-quantity-modal',
    children: (
      <ModificaQuantita
        selectedArticolo={selectedArticolo}
        initialQuantita={initialQuantita}
        service_gift={service_gift}
        prodotto={prodotto}
      />
    ),
  }
}

const ModificaQuantita = ({ initialQuantita, selectedArticolo, service_gift, prodotto }) => {
  const t = useTrans()
  const { onChangeInputQuantita, handleQuantita } = useContext(QuantitaContext)

  const withTaglie =
    selectedArticolo?.attributi_lista?.filter((attributo) => attributo.attributo === 8).length > 0
      ? true
      : false

  const _withInchiostro =
    selectedArticolo?.attributi_lista?.filter((attributo) => attributo.attributo === 6)?.length > 0
      ? true
      : false

  const n_cols = service_gift?.attivo
    ? _.omit(withTaglie ? cols : colsMenoTaglia, ['prossimi_arrivi'])
    : withTaglie
      ? cols
      : colsMenoTaglia

  return (
    <div>
      <div className="info__quantita">
        <div className="info__quantita__wrapper">
          {selectedArticolo?.acquistabile_multipli !== 0 && (
            <div style={{ marginBottom: 24 }}>
              <Alert
                variant="info"
                placeholder={t('Articolo acquistabile solo a multipli di {0} pezzi', [
                  selectedArticolo?.acquistabile_multipli,
                ])}
              />
            </div>
          )}

          {prodotto?.personalizzabile && prodotto?.quantita_minima_personalizzabile && (
            !service_gift || service_gift?.personalizzazione) && (
              <p>
                {t('*Quantità minima personalizzabile:')}{' '}
                <strong>{prodotto?.quantita_minima_personalizzabile}</strong>
              </p>
            )}

          {!service_gift?.attivo && (
            <p>
              <strong>{t('*Sconto extra del 2%')}</strong>{' '}
              {t('se mantieni gli imballi')}{': '}
              <strong>{selectedArticolo.imballi}</strong>{' '}
              {t('pezzi')}
              {selectedArticolo.sotto_imballi && selectedArticolo.sotto_imballi > 0 ? (
                <>
                  {' '}{t('e/o sottoimballi')}{': '}
                  <strong>{selectedArticolo.sotto_imballi}</strong>{' '}
                  {t('pezzi')}
                </>
              ) : null}
            </p>
          )}

        </div>
      </div>

      {selectedArticolo && (
        <Datatable cols={_withInchiostro ? n_cols : _.omit(n_cols, ['inchiostro'])}>
          <DatatableRowProdotto
            isEdit={true}
            cols={_withInchiostro ? n_cols : _.omit(n_cols, ['inchiostro'])}
            initialValue={initialQuantita}
            id={selectedArticolo.id}
            isFirstElement={true}
            imballi={selectedArticolo?.imballi}
            sotto_imballi={selectedArticolo?.sotto_imballi}
            prezzo={selectedArticolo.prezzo}
            disponibilita={selectedArticolo.disponibilita}
            quantita_reale_magazzino={selectedArticolo.quantita_reale_magazzino}
            disponibilita_reale_maggiore={selectedArticolo.disponibilita_reale_maggiore}
            disponibilita_in_opzione={selectedArticolo.disponibilita_in_opzione}
            data_in_opzione={selectedArticolo.data_in_opzione}
            multipli={
              selectedArticolo.acquistabile_multipli ? selectedArticolo.acquistabile_multipli : 0
            }
            codice={selectedArticolo.codice}
            prossimi_arrivi={selectedArticolo.prossimi_arrivi}
            onChangeInputQuantita={onChangeInputQuantita}
            handleQuantita={handleQuantita}
            colore={
              selectedArticolo?.attributi_lista?.filter((attributo) => attributo.attributo === 7)[0]
            }
            taglia={
              selectedArticolo?.attributi_lista?.filter((attributo) => attributo.attributo === 8)[0]
                ?.nome
            }
          />
        </Datatable>
      )}
    </div>
  )
}

export default ModificaArticoli
